import type { Table } from '@tanstack/react-table';
import { cn } from '@/lib/cn';
import { Skeleton } from '../../ui/skeleton';
import { TableCell, TableRow } from '../../ui/table';
import { getColumnPinningClassName, getColumnPinningStyle } from './getColumnPinningClassNames';
interface SkeletonRowProps<TData> {
  /** TanStack Tableインスタンス */
  table: Table<TData>;
  /** 行のインデックス（キー生成用） */
  rowIndex: number;
  /** スクロール状態（カラム固定時の影表示用） */
  isScrolling: boolean;
}
const getSkeletonWidth = (columnIndex: number): string => {
  const widths = ['128px', '96px', '80px', '112px', '64px'];
  return widths[columnIndex % widths.length];
};

/**
 * スケルトンローディング行コンポーネント
 * ローディング状態でのスケルトン表示に関する責任を持つ
 */
export function SkeletonRow<TData>({
  table,
  rowIndex,
  isScrolling
}: SkeletonRowProps<TData>) {
  return <TableRow key={`skeleton-${rowIndex}`}>
      {table.getVisibleLeafColumns().map((column, columnIndex) => <TableCell key={`skeleton-cell-${rowIndex}-${column.id}`} className={cn('first:pl-6', getColumnPinningClassName(column, isScrolling))} style={{
      // カラムピン状態の定義をtailwindで実現できないので、styleで指定する
      // 2カラムピンする場合に、カラム幅に応じて動的にleft-[120px]のようなクラスを生成する必要があるが、それができないためである
      ...getColumnPinningStyle(column),
      ...(column.columnDef.meta?.thStyle ?? {})
    }}>
          <Skeleton variant="text" width={getSkeletonWidth(columnIndex)} />
        </TableCell>)}
    </TableRow>;
}